<template>
  <div class="t-filter-collection">
    <div class="t-filter-collection__filters">
      <component
        v-for="filter in activeFilters"
        :is="filter.component"
        :key="filter.key"
        v-model="filters[filter.key]"
        v-bind="filter.props"
      />
    </div>

    <t-button v-if="activeFilters.length" @click="applyFilters">
      {{ applyLabel }}
    </t-button>
  </div>
</template>

<script>
export default {
  name: 't-filter-collection',

  props: {
    apply: {
      type: Function,
      required: true,
    },

    filtersData: {
      type: Object,
      default: () => {},
    },

    enabledFilters: {
      type: Array,
      default: () => [],
    },

    availableFilters: {
      type: Array,
      default: () => [],
    },

    applyLabel: {
      type: String,
      required: false,
      default: 'Apply filter',
    },
  },

  created() {
    this.filters = { ...this.filtersData };
  },

  data() {
    return {
      filters: {},
    };
  },

  computed: {
    activeFilters() {
      return this.availableFilters.filter((filter) => this.enabledFilters.includes(filter.key));
    },
  },

  methods: {
    applyFilters() {
      this.apply(this.filters);
    },
  },

  watch: {
    filters: {
      deep: true,
      handler(value) {
        this.$emit('update', value);
      },
    },
  },
};
</script>
